import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import * as React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Tooltip from '../Tooltip';

var Icon = function Icon(props, ref) {
  var type = props.type,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'regular' : _props$variant,
      className = props.className,
      tooltip = props.tooltip,
      others = _objectWithoutProperties(props, ["type", "variant", "className", "tooltip"]);

  var _className = classnames(className, 'Icon', "Icon--".concat(type), _defineProperty({}, "Icon--".concat(variant), !!variant));

  if (!tooltip) {
    return React.createElement("i", Object.assign({}, others, {
      className: _className,
      "aria-hidden": "true",
      ref: ref
    }));
  }

  return React.createElement(Tooltip, {
    placement: "bottom",
    content: tooltip,
    delay: 0.05,
    ref: ref
  }, React.createElement("i", Object.assign({}, others, {
    className: _className,
    "aria-hidden": "true"
  })));
};

var _Icon = React.forwardRef(Icon);

_Icon.propTypes = {
  type: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(['light', 'regular', 'solid', 'duotone']),
  tooltip: PropTypes.node,
  className: PropTypes.string
};
export { Icon as IconInner };
export default _Icon;